function isConsumerAction(action) {
    if (action && typeof action === 'object' && 'type' in action) {
        return true;
    }
    return false;
}
export { isConsumerAction, };
